import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["date", "label"];
import React, { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RenderDay(props) {
  var {
    prefixCls,
    day,
    data,
    currentDate
  } = props;
  var dayData = useMemo(() => (data || []).filter(item => {
    var arr = (item.date && item.date.split('/') || []).map(num => Number(num));
    if (arr.length === 1) {
      return day === arr[0];
    }
    if (currentDate && arr.length === 2) {
      return currentDate.getMonth() + 1 === arr[0] && day === arr[1];
    }
    if (currentDate && arr.length === 3) {
      return currentDate.getFullYear() === arr[0] && currentDate.getMonth() + 1 === arr[1] && day === arr[2];
    }
    return false;
  }), [currentDate, day, data]);
  return useMemo(() => /*#__PURE__*/_jsxs("div", {
    className: prefixCls + "-inner",
    children: [/*#__PURE__*/_jsx("div", {
      className: prefixCls + "-day",
      children: day
    }), /*#__PURE__*/_jsx("div", {
      className: prefixCls + "-panel",
      children: dayData && dayData.length > 0 && dayData.map((item, idx) => {
        var {
            label
          } = item,
          other = _objectWithoutPropertiesLoose(item, _excluded);
        return /*#__PURE__*/_jsx("div", _extends({}, other, {
          children: label
        }), idx);
      })
    })]
  }), [dayData, day]);
}